import React from 'react'

const EnergyBoltingBrand = () => (
  <svg className="icon">
    <use
      xlinkHref={`/Static/Images/icons.svg?=${process.env.BUILD_VERSION_ID}#icon--energy-bolting-brand`}
    />
  </svg>
)

export default EnergyBoltingBrand
